import React from 'react';

import emailjs from 'emailjs-com';
import ContactService from '../../services/contact.service';

const ContactForm = (props) => {
    const intialState={
        name:"",
        phone:"",
        email:"",
        subject:"",
        message:""
    }
    const [formData,setFormData]=React.useState({...intialState});
    const [error,setError]=React.useState({...intialState});
    const [loading,setLoading]=React.useState(false);

    const handleValidation=()=>{
        // Required Validation
        let errors={};
            Object.keys(intialState).map((field)=>{
                if(formData[field]===""){
                    errors[field]=` ${field} is required`;
                }
            });
            setError(errors);
            if(Object.keys(errors)>0) return false;
            return true;

    }


    const handleChange=(e)=>{
        const {name,value}=e.target;
        setFormData(prev=>({...prev,[name]:value}));
        setError(prev=>({...prev,[name]:""}));
    };

    const handleSubmit=async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
        // Handle the Validation
            if( !handleValidation()) return ;

            const res=await ContactService.save(formData);
            if(res.success){
                alert(res.message);
                setFormData({...intialState});
            }
            
        } catch (error) {
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    // function sendEmail(e) {
    //     e.preventDefault();

    //     emailjs.sendForm('', '', e.target, '')
    //     .then((result) => {
    //         console.log(result.text);
    //     }, (error) => {
    //         console.log(error.text);
    //     });

    //     e.target.reset()
    // } 

    return (
        <div className="react-blog-form">
            <h2 className="contact-title">Questions? <br/> Feel free to contact us</h2>
            <div id="blog-form" className="blog-form">
                <div id="form-messages"></div>
                <form id="contact-form"  >                                                    
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="back-input">
                                <input id="name" type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Name" />
                                <p className='text-danger'>{error.name}</p>
                            </div>
                        </div>

                        <div className="col-lg-6 pdl-5">
                            <div className="back-input">
                                <input id="email" type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Email" />          
                                <p className='text-danger'>{error.email}</p>
                            </div>
                        </div>
                        
                        <div className="col-lg-6">
                            <div className="back-input">
                                <input id="subject" type="text" name="subject" value={formData.subject} onChange={handleChange} required placeholder="Subject" />  
                                <p className='text-danger'>{error.subject}</p>
                            </div>
                        </div>

                        <div className="col-lg-6 pdl-5">
                            <div className="back-input">
                                <input id="phone" type="text" name="phone" value={formData.phone} onChange={handleChange} required placeholder="Phone" />  
                                <p className='text-danger'>{error.phone}</p>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="back-textarea">
                                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required placeholder="Message"></textarea>
                                <p className='text-danger'>{error.message}</p>
                            </div>
                        </div>

                        <div className="col-lg-12">                                                
                            <button type="submit" onClick={handleSubmit} className="back-btn">{loading?<div className='spinner-border spinner-border-sm'></div>
                               : (<>Send Message <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                               </> )}
                            </button>
                        </div>
                    </div>                                                    
                </form>
            </div>
        </div>
    );

}

export default ContactForm;